module.exports = __webpack_public_path__ + "static/media/image_11.f7b86642.jpg";